import styled from 'styled-components';
import { space } from 'styled-system';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import LinkComp from '../../atoms/Link';
import Flex from '../../atoms/Flex';
export const FooterMenuWrapper = styled.nav`
  background-color: ${props => getBackgroundColor('white')(props)};
  width: fit-content;
  padding: 20px;
`;
export const FooterList = styled.ul`
  list-style: none;
  display: flex;
`;
export const FooterItem = styled.li.attrs(() => ({
  mr: 3
}))`
  display: flex;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  width: max-content;

  ${space}
`;
export const Link = styled(LinkComp)``;
export const ImageWrapper = styled(Flex).attrs(props => Object.assign({
  color: 'text.primary',
  m: 0
}, props))``;